<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-08-03 14:54:15
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-21 18:06:05
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperativeShop\collaborateRules\editRules\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row flex-just-center edit-content" style="padding-bottom: 80px">
		<rules-oper :platformId="platformId" :rules="rules" class="mt-24" @handleFormChange="handleFormChange" />
		<div class="pos-fix footer align-center">
			<el-button @click="close">取消</el-button>
			<el-button type="primary" @click="submit">保存</el-button>
		</div>
	</div>
</template>
<script>
import rulesOper from '../../components/rulesOper.vue';
import { institutionSaveRule, institutionGetRule } from '@/api/cooperativeShop';
export default {
	components: {
		rulesOper,
	},
	computed: {
		platformId() {
			return this.$route.query.platform_id;
		},
	},
	created() {
		this.getRules();
	},
	data() {
		return {
			form: {},
			rules: {},
		};
	},
	methods: {
		async getRules() {
			const data = await institutionGetRule({ platformId: this.platformId, shopId: 0 });
			this.rules = data;
		},
		async submit() {
			const { platformId, form } = this;
			await institutionSaveRule({ platformId, shopId: 0, ...form });
			this.$message.success('编辑成功！');
			let timer = setTimeout(() => {
				this.$router.push({
					path: '/cooperativeShop/collaborateRules/viewRules',
				});
				clearTimeout(timer);
			}, 1000);
		},
		close() {
			this.$modal({
				title: '提示',
				contentTitle: '是否确认取消',
				size: 'small',
			}).then(res => {
				if (res.key == 'confirm') {
					this.$router.go(-1);
					res.done();
				} else {
					res.done();
				}
			});
		},
		handleFormChange(val) {
			this.form = val;
		},
	},
};
</script>
<style lang="less" scoped>
.edit-content{
	height: calc(100vh - 250px);
}
.footer {
	width: calc(100% - 164px);
	bottom: 0px;
	height: 64px;
	line-height: 64px;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.04);
}
</style>
